import { render, staticRenderFns } from "./lxvideo.vue?vue&type=template&id=9ae62aaa&scoped=true&"
import script from "./lxvideo.vue?vue&type=script&lang=js&"
export * from "./lxvideo.vue?vue&type=script&lang=js&"
import style0 from "./lxvideo.vue?vue&type=style&index=0&id=9ae62aaa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ae62aaa",
  null
  
)

export default component.exports